import apiClient from '../client'

export interface Voice {
  id: string
  name: string
  description?: string
  public?: boolean
  ratings?: number
  average_rating?: number
  tags?: string[]
  gender?: string
  language?: string
  accent?: string
}

export interface VoicesResponse {
  voices: Voice[]
  total: number
  default_voice_id: string
}

export interface VoicePreviewResponse {
  success: boolean
  audio_data?: string
  content_type?: string
}

export const voicesApi = {
  /**
   * List all available voices from Bland.ai
   */
  getAll: () =>
    apiClient.get<VoicesResponse>('/api/inbound/voices'),

  /**
   * Generate a voice preview (TTS audio) for a given voice
   * Uses longer timeout (60s) as TTS generation can be slow
   */
  preview: (voiceId: string, text: string) =>
    apiClient.post<VoicePreviewResponse>(
      '/api/inbound/voices/preview',
      {
        voice: voiceId,
        text,
      },
      {
        timeout: 60000, // 60 second timeout for TTS generation
      }
    ),
}
